import { useSettingMenuItems } from '@hooks/useSettingMenuItems'
import { extractSectionFromPath } from '@supplement-bacon/react-toolkit/utils'
import { Menu } from 'antd'
import Sider from 'antd/es/layout/Sider'
import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export const SettingsSider: FC = () => {
  const { pathname } = useLocation()
  const { menuItems } = useSettingMenuItems()
  const [selectedKey, setSelectedKey] = useState<string>('plaforms')

  useEffect(() => {
    const segments = pathname.split('/').filter(Boolean)
    if (segments.at(-1) === 'list') {
      const key = segments.slice(-2).join('-')
      setSelectedKey(key)
    } else {
      setSelectedKey(extractSectionFromPath(pathname, segments.length))
    }
  }, [pathname])

  return (
    <Sider
      width={300}
      style={{
        position: 'fixed',
        top: 64,
        height: 'calc(100vh - 64px)',
        overflowY: 'scroll',
      }}
    >
      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        style={{ minHeight: '100%', borderRight: 0 }}
        items={menuItems}
      />
    </Sider>
  )
}
